import { Clapperboard, Workflow, Database, ClipboardList } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const Label = ({ children }) => (
  <span className="text-xs font-semibold uppercase tracking-[0.16em] text-[var(--ember)]">
    {children}
  </span>
);

const ITEMS = [
  { icon: Clapperboard, t: "A full content engine, every month", d: "Scripts, video, statics, and creative built for your market — not recycled templates." },
  { icon: Workflow, t: "A production line you never touch", d: "Research, planning, scripting, production, publishing, and reporting — eight agents on the line, run by your named expert. None of it lands on your desk." },
  { icon: Database, t: "A CRM and funnel in your own account", d: "Lead capture through nurture, built on infrastructure that belongs to you." },
  { icon: ClipboardList, t: "One source of truth for reporting", d: "What ran, what it returned, and what's next — in plain language." },
];

export const WhatYouGet = () => (
  <section id="what-you-get" className="scroll-mt-24 bg-[var(--bg-contrast)] py-28 md:py-36" data-testid="growth-what-you-get">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="max-w-2xl">
        <Reveal><Label>What you get</Label></Reveal>
        <Reveal delay={80}><h2 className="mt-7 t-section">What actually lands in your business.</h2></Reveal>
        <Reveal delay={140}>
          <p className="mt-6 text-base leading-relaxed text-[var(--muted)] sm:text-lg">
            We won't promise a lead count — that's not how honest marketing works. Here's what you can count on receiving, every month, and keeping for good.
          </p>
        </Reveal>
      </div>
      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {ITEMS.map((c, i) => (
          <Reveal key={c.t} delay={(i % 4) * 80}>
            <div className="flex h-full flex-col rounded-2xl border border-black/5 bg-[var(--bg-base)] p-7">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[var(--ember)]/10 text-[var(--ember)]">
                <c.icon size={20} strokeWidth={1.8} />
              </span>
              <h3 className="mt-5 text-lg font-semibold tracking-[-0.02em] text-[var(--ink)]">{c.t}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-[var(--muted)]">{c.d}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={360}>
        <p className="mt-12 text-lg font-semibold tracking-tight text-[var(--ember)]">
          And every asset we build stays yours.
        </p>
      </Reveal>
    </div>
  </section>
);
